import { Box, Button, Checkbox, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useState } from "react";
import CommonFileUploader from "./CommonFileUploader";
import { FilePreviewCard } from "./PreviewUploading";
import axios from "axios";
import ValidationStatus from "./ValidationStatus";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../../context/global";
import useUserDetails from "../../../helper/userData/useUserDetails";
import HistoryModal from "./HistoryModal";

function UploadCatalogContent({ jobType, selectedChannel }) {
  const [userDetails] = useUserDetails();
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const { clientId } = useGlobalContext();
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [validationStatusData, setValidationStatusData] = useState({});
  const [isValidating, setIsValidating] = useState(false);
  const [formData, setFormData] = useState({
    blobUrl: "",
    // uploadAction: jobType === "FK_STATS_CSV_SYNC" ? "WRITE_APPEND" : "", //OVER_WRITE, WRITE_APPEND (over existing listing)
    uploadAction: "WRITE_APPEND", //OVER_WRITE, WRITE_APPEND (over existing listing)
    jobType: jobType, //FK_LISTING_CSV_SYNC (for listing data)/ FK_STATS_CSV_SYNC (for order data)
    deltaAction: "PAUSE", //PAUSE, KEEP_AS_IT_IS
    userEmail: userDetails?.user?.email,
  });

  const templateConfigs = {
  FK_LISTING_CSV_SYNC: {
    url: "https://storage.googleapis.com/adyogi_marketplace/Flipkart%20Listing%20Template.csv",
    name: "Flipkart Listing Template.csv",
  },
  FK_STATS_CSV_SYNC: {
    url: "https://storage.googleapis.com/adyogi_marketplace/Flipkart%20Order%20Template.csv",
    name: "Flipkart Order Template.csv",
  },
  MYNTRA_LISTING_CSV_SYNC: {
    url: "https://storage.googleapis.com/adyogi_marketplace/Myntra%20Listing%20Template.csv",
    name: "Myntra Listing Template.csv",
  },
  MYNTRA_STATS_CSV_SYNC: {
    url: "https://storage.googleapis.com/adyogi_marketplace/Myntra%20Order%20Template.csv",
    name: "Myntra Order Template.csv",
  },
  AMAZON_LISTING_CSV_SYNC: {
    url: "https://storage.googleapis.com/adyogi_marketplace/Amazon%20Listing%20Template.csv",
    name: "Amazon Listing Template.csv",
  },
  AMAZON_STATS_CSV_SYNC: {
    url: "https://storage.googleapis.com/adyogi_marketplace/Amazon%20Order%20Template.csv",
    name: "Amazon Order Template.csv",
  },
};
const sampleTemplateConfig = templateConfigs[jobType] || null;

  const handleValidationAndSubmit = async (
    bodyFormData = formData,
    type = "VALIDATION"
  ) => {

    if (formData.uploadAction === "WRITE_APPEND") {
      bodyFormData.deltaAction = "KEEP_AS_IT_IS";
    } else {
      bodyFormData.deltaAction = "PAUSE";
    }
    const path = type === "SUBMIT" ? "validate-and-process-csv" : "validate-csv";
    const endPointURL = `${process.env.REACT_APP_CATALOG_API}/client/${clientId}:${path}?source=${selectedChannel}`;
    // if (type === "VALIDATION") {
    //   if (!bodyFormData.uploadAction) {
    //     return toast.error("Please select Job type.");
    //   }
    // }
    // if (type === "SUBMIT") {
    //   if (
    //     !bodyFormData.deltaAction &&
    //     validationStatusData.status === "warning"
    //   ) {
    //     return toast.error(
    //       "Please select warning type like (keep as it is/pause)."
    //     );
    //   }
    // }

    setIsValidating(type);
    try {
      const { data } = await axios.post(endPointURL, bodyFormData);

      const commonData = {
        currentRows: data.currentRows || 0,
        uploadedRows: data.rowsScanned || 0,
        delta: data.delta || 0,
      };

      if (type === "SUBMIT" && !!data.valid) {
        toast.success("Data has been saved successfully!.");
        setValidationStatusData((prev) => {
          return { status: "" };
        });
        setFile(null);
        setProgress(0);
        setFormData((prev) => {
          return { ...prev, blobUrl: "", uploadAction: "" };
        });
        return "";
      }

      if (!!data.valid && data.errors.length === 0) {
        setValidationStatusData({
          ...commonData,
          status: "success",
        });
      } else if (data.valid && data.errors.length > 0) {
        setValidationStatusData({
          ...commonData,
          status: "warning",
          warningAndErrorsData: data.errors,
        });
      } else if (!data.valid && data.errors.length > 0) {
        setValidationStatusData({
          ...commonData,
          status: "error",
          warningAndErrorsData: data.errors,
        });
      }
    } catch (err) {
      toast.error("Unable to validate file, Please try again!");
      setValidationStatusData({});
    } finally {
      setIsValidating(false);
    }
  };

const handleUploadBlob = async (file) => {
  if (!file) return toast.error("Please select a file first.");

  try {
    setProgress(0);

    // 1. Request pre-signed upload URL
    const res = await fetch(`${process.env.REACT_APP_LOGIN_API}/api/gcp/preSignedUrl`, {
      method: "POST",
      headers: { "Content-Type": "application/json", 'Authorization': `${process.env.REACT_APP_AUTHORIZATION_FOR_NORMAL_USER}`},
      body: JSON.stringify({ filename: file.name, contentType: file.type }),
    });

    const data = await res.json();
    if (!res.ok || !data?.uploadUrl)
      throw new Error(data.error || "Failed to get upload URL");

    // 2. Upload file to GCS directly
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", data.uploadUrl, true);
    xhr.setRequestHeader("Content-Type", file.type);

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded * 100) / event.total);
        setProgress(percent);
      }
    };

    const uploadPromise = new Promise((resolve, reject) => {
      xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 201) {
          setProgress(100);
          resolve();
        } else {
          reject(new Error("Upload to GCS failed"));
        }
      };
      xhr.onerror = () => reject(new Error("Upload failed due to network error"));
      xhr.send(file);
    });

    await uploadPromise;

    const fileURL = data.publicUrl;
    if (!fileURL) throw new Error("No public URL returned");

    setFormData((prev) => {
      const updated = { ...prev, blobUrl: fileURL };
      handleValidationAndSubmit(updated);
      return updated;
    });
  } catch (error) {
    console.error("Upload failed:", error);
    toast.error(`Upload failed: ${error.message}`);
  }
};



  const downloadFile = (url, filename = "download.csv") => {
    try {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.setAttribute("target", "_blank"); // ensure it opens/downloads correctly
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Box
      p={2}
      flex={1}
      display={"flex"}
      flexDirection="column"
      gap={2}
      overflow="auto"
    >
      {/* <Typography variant="body1" fontWeight="semibold">
        {jobType === "FK_LISTING_CSV_SYNC"
          ? "How you want to update your catalog"
          : "Upload Order Data"}
      </Typography> */}
      {[
        "FK_LISTING_CSV_SYNC",
        "MYNTRA_LISTING_CSV_SYNC",
        "AMAZON_LISTING_CSV_SYNC",
      ].includes(jobType) && (
        <Box display="flex" gap={2} mb={1}>
          {[
            {
              id: "OVER_WRITE",
              title: "Refresh Entire Listing",
              desc: "This will remove your existing listing data and replace it with the new upload.",
            },
            {
              id: "WRITE_APPEND",
              title: "Update Existing Listing",
              desc: "This will add new products to your existing listing without removing any current data.",
            },
          ].map((card, idx) => (
            <Box
              key={idx}
              onClick={() => {
                setFile(null);
                setProgress(0);
                setValidationStatusData({});
                setFormData((prev) => ({
                  ...prev,
                  blobUrl: "",
                  uploadAction: card.id,
                }));
              }}
              sx={{
                flex: 1,
                position: "relative",
                py: 1.5,
                px: 2,
                pr: 5,
                border: "1px solid",
                borderColor: `${
                  card.id === formData.uploadAction ? "primary.main" : "#E1E3E5"
                }`,
                bgcolor: `${
                  card.id === formData.uploadAction ? "#F7F6FF" : "#fff"
                }`,
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s",
              }}
            >
              <Checkbox
                checked={card.id === formData.uploadAction}
                tabIndex={-1}
                disableRipple
                icon={
                  <RadioButtonUncheckedIcon
                    sx={{ fontSize: 22, color: "#E1E3E5" }}
                  />
                }
                checkedIcon={
                  <CheckCircleIcon
                    sx={{ fontSize: 22, color: "primary.main" }}
                  />
                }
                sx={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  p: 0.5,
                  pointerEvents: "none",
                }}
              />
              <Typography
                sx={{
                  color: `${
                    card.id === formData.uploadAction ? "primary.main" : "auto"
                  }`,
                }}
                variant="subtitle2"
                fontWeight="bold"
                gutterBottom
              >
                {card.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {card.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      )}

      {/* Upload Box */}
      {isValidating !== "VALIDATION" && <Box>
        <Box
          sx={{
            color: "primary.main",
            display: "flex",
            gap: "24px",
            justifyContent: "flex-end",
            width: "100%",
            mb: 1,
          }}
        >
          {/* Download Link */}
          <Typography
            variant="body2"
            component="span"
            onClick={() =>
              downloadFile(sampleTemplateConfig.url, sampleTemplateConfig.name)
            }
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
              fontWeight: 500,
              textDecoration: "none",
              color: "primary.main",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            <DownloadIcon fontSize="small" />
            Download Template
          </Typography>

          {/* Upload History Button */}
          <Typography
            variant="body2"
            onClick={() => {
              setShowHistoryModal(true);
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
              fontWeight: 500,
              "&:hover": { textDecoration: "underline" },
            }}
          >
            <VisibilityIcon fontSize="small" />
            Upload History
          </Typography>
        </Box>
        <CommonFileUploader
          onFileSelect={(file) => {
            setFile(file);
            setProgress(0);
            setFormData((prev) => {
              return { ...prev, blobUrl: "" };
            });
            setValidationStatusData({});
            handleUploadBlob(file);
          }}
        />
      </Box>}
      {file && (
        <FilePreviewCard
          key={file}
          fileName={file?.name}
          fileSize={file?.size}
          status={progress === 100 ? "Uploaded" : "Uploading..."}
          showDeleteIcon={isValidating !== "VALIDATION"}
          onDelete={() => {
            setFile(null);
            setProgress(0);
            setFormData((prev) => {
              return { ...prev, blobUrl: "" };
            });
            setValidationStatusData({});
          }}
          progress={progress}
        />
      )}
      <ValidationStatus
        key={validationStatusData.status}
        status={
          isValidating === "VALIDATION"
            ? "validating"
            : validationStatusData.status
        }
        uploadAction={formData.uploadAction}
        validationStatusData={validationStatusData}
        // selectedWarningType={formData.deltaAction}
        // onWarningSelect={(warningType) => {
        //   return setFormData((prev) => {
        //     return { ...prev, deltaAction: warningType };
        //   });
        // }}
      />
      {validationStatusData.status === "success" ||
      validationStatusData.status === "warning" ? (
        <Box width={100}>
          <Button
            onClick={() => {
              handleValidationAndSubmit(formData, "SUBMIT");
            }}
            variant="contained"
            color="primary"
          >
            {isValidating === "SUBMIT" ? "Submitting..." : "Submit"}
          </Button>
        </Box>
      ) : null}
      <HistoryModal
        key={jobType}
        open={showHistoryModal}
        onClose={() => {
          setShowHistoryModal(false);
        }}
        jobType={jobType}
      />
    </Box>
  );
}

export default UploadCatalogContent;
